module.exports = __webpack_public_path__ + "static/GPtooth-eb56c882429e5c51183b98e10914cbb8.png";